import React, { useState } from 'react';
import InviteModal from './InviteModal';

const STATUS_CLASS = {
  pending: 'bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-200',
  approved: 'bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-200',
  denied: 'bg-gray-200 text-gray-700 dark:bg-gray-700 dark:text-gray-200',
  invited: 'bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200',
  active: 'bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200',
};

export default function CandidateRow({ candidate: c, selected, onToggle, onApprove, onDeny, onInvited }) {
  const [inviteOpen, setInviteOpen] = useState(false);
  return (
    <tr className="border-b border-gray-200 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-800">
      <td className="p-2">
        <input type="checkbox" disabled={!['pending', 'approved'].includes(c.status)} checked={selected} onChange={onToggle} />
      </td>
      <td className="p-2 dark:text-gray-100">
        {c.company_name || `Company #${c.processor_company_id}`}
        {c.shared_contact_count > 0 && (
          <span
            title={`This contact email is shared with ${c.shared_contact_count} other client${c.shared_contact_count === 1 ? '' : 's'}`}
            className="ml-2 px-1.5 py-0.5 rounded text-xs bg-orange-100 text-orange-700 dark:bg-orange-900/40 dark:text-orange-300"
          >
            shared contact ×{c.shared_contact_count + 1}
          </span>
        )}
      </td>
      <td className="p-2 dark:text-gray-300">
        {c.contact_email || <span className="text-gray-400 dark:text-gray-500">no contact</span>}
      </td>
      <td className="p-2 dark:text-gray-300">{c.state || '—'}</td>
      <td className="p-2 dark:text-gray-300">
        {c.last_activity_on || '—'}
        {c.eligible
          ? <span className="ml-2 px-1.5 py-0.5 rounded text-xs bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-200">eligible</span>
          : <span className="ml-2 px-1.5 py-0.5 rounded text-xs bg-gray-200 text-gray-600 dark:bg-gray-700 dark:text-gray-300">stale</span>}
      </td>
      <td className="p-2 dark:text-gray-300">
        {c.contact_last_login_on
          ? c.contact_last_login_on
          : <span className="px-1.5 py-0.5 rounded text-xs bg-gray-200 text-gray-600 dark:bg-gray-700 dark:text-gray-300">no login</span>}
      </td>
      <td className="p-2 dark:text-gray-300">{c.child_company_count > 0 ? `${c.child_company_count} children` : 'Standalone'}</td>
      <td className="p-2">
        <span className={`px-2 py-1 rounded text-xs ${STATUS_CLASS[c.status] || 'bg-gray-100 text-gray-700'}`}>{c.status}</span>
      </td>
      <td className="p-2 whitespace-nowrap">
        {c.status === 'pending' && (
          <>
            <button onClick={onApprove} className="px-2 py-1 bg-blue-600 text-white rounded text-xs mr-1 hover:bg-blue-700">Approve</button>
            <button onClick={onDeny} className="px-2 py-1 border border-gray-300 dark:border-gray-600 text-gray-700 dark:text-gray-200 rounded text-xs hover:bg-gray-50 dark:hover:bg-gray-700">Deny</button>
          </>
        )}
        {c.status === 'approved' && (
          <button onClick={() => setInviteOpen(true)} className="px-2 py-1 bg-orange-500 text-white rounded text-xs hover:bg-orange-600">✉ Invite</button>
        )}
      </td>
      {inviteOpen && (
        <InviteModal candidate={c} onClose={() => setInviteOpen(false)} onInvited={() => { setInviteOpen(false); onInvited(); }} />
      )}
    </tr>
  );
}
